import React from 'react'
import { Form } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import SearchSelect from '../../components/SearchSelect'
import { useGetSelectDriversQuery } from '../../redux/services/DriverService'
import LoadingButtonWithForm from '../../components/LoadingButtonWithForm'
import LoadingButton from '../../components/LoadingButton'
import MultiSelect from '../../components/MultiSelect'

const Filter = ({ setQuery }) => {
    let {
        control,
        register,
        handleSubmit,
        setValue,
        watch,
        reset,
        formState: { errors },
    } = useForm()

    const empStatus = [{ title: 'Active', id: 0 }, { title: 'Terminated', id: 1 }, { title: 'Leave', id: 2 }]

    const onSubmit = async (data) => {

        data['employment_status'] = data?.employment_status?.length > 0 ? data?.employment_status?.map((item) => item?.value)?.join(',') : '';

        console.log('d', data)
        // send data as a query params

        if (data?.employment_status) {
            setQuery({ id: data?.employment_status })
        }
    }
    return (
        <>
            <div className="p-4" id="collapse-inputs">
                <Form className='row align-items-end' onSubmit={handleSubmit(onSubmit)} id='filter-management'>
                    <div className="col-lg-4">
                        <Form.Group className="mb-0">
                            <Form.Label>Select Employment Status:</Form.Label>
                            <Controller
                                name="employment_status"
                                control={control}
                                defaultValue=""
                                rules={{
                                    required: false
                                }}
                                render={({ field }) => (
                                    <>
                                        {/* <SearchSelect
                                            options={empStatus?.map((item) => ({ value: item?.id, label: item?.title }))}
                                            field={field}
                                            placeholder={"Select Employment Status"}
                                        /> */}
                                        <MultiSelect
                                            options={
                                                [
                                                    { value: 0, label: 'Active' },
                                                    { value: 2, label: 'Leave' }
                                                ]
                                            }
                                            field={field}
                                            placeholder={"Select Employment Status"}
                                        />
                                        {errors.employment_status && <div className="invalid-feedback d-block">This field is required</div>}
                                    </>

                                )}
                            />
                        </Form.Group>
                    </div>
                    <div className="col-lg-2 col-md-4">
                        <LoadingButton
                            // isLoading={editLoading ? editLoading : addLoading}
                            name="Reset Filter"

                            className='w-100'
                            onClick={() => {
                                reset({
                                    employment_status: '',
                                })
                                console.log('reset')
                                setQuery(null)
                            }}
                            type="button"
                        />
                    </div>
                    <div className="col-lg-2 col-md-4">
                        <LoadingButtonWithForm
                            // isLoading={editLoading ? editLoading : addLoading}
                            name="Filter"
                            form="filter-management"
                            className='w-100'
                        />
                    </div>


                </Form>
            </div>

        </>
    )
}

export default Filter